import { render, staticRenderFns } from "./OldStoreTitlebar.vue?vue&type=template&id=3dc9781c&scoped=true"
import script from "./OldStoreTitlebar.vue?vue&type=script&lang=js"
export * from "./OldStoreTitlebar.vue?vue&type=script&lang=js"
import style0 from "./OldStoreTitlebar.vue?vue&type=style&index=0&id=3dc9781c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc9781c",
  null
  
)

export default component.exports